/**
 * Product Material Info — Variant-aware material/safety card
 * Listens for variant:update events on document level (pdp-details is a
 * separate section from the variant picker, so section-scoped events don't reach us).
 * On variant change: fetches the pdp-details section HTML with the new variant and swaps content.
 */

class ProductMaterialInfo extends HTMLElement {
  connectedCallback() {
    this._onVariantUpdate = this._onVariantUpdate.bind(this);
    document.addEventListener('variant:update', this._onVariantUpdate);
  }

  disconnectedCallback() {
    document.removeEventListener('variant:update', this._onVariantUpdate);
  }

  _onVariantUpdate(event) {
    const variantId = event.detail.resource?.id;
    if (!variantId) return;

    // Fetch the pdp-details section with the new variant
    const sectionId = this.closest('.shopify-section')?.id?.replace('shopify-section-', '');
    if (!sectionId) return;

    const productUrl = window.location.pathname;
    const url = `${productUrl}?variant=${variantId}&section_id=${sectionId}`;

    fetch(url)
      .then((res) => res.text())
      .then((text) => {
        const html = new DOMParser().parseFromString(text, 'text/html');
        const selector = `product-material-info[data-block-id="${this.dataset.blockId}"]`;
        const newElement = html.querySelector(selector);
        if (!newElement) return;

        const newContent = newElement.querySelector('[ref="content"]');
        const currentContent = this.querySelector('[ref="content"]');
        if (newContent && currentContent) {
          currentContent.innerHTML = newContent.innerHTML;
        }
      })
      .catch(() => {});
  }
}

if (!customElements.get('product-material-info')) {
  customElements.define('product-material-info', ProductMaterialInfo);
}
